<template>
  <div
    v-show="loading.active"
    :class="loading.clickAble ? 'cs-pointer' : ''"
    class="main-content overlay"
    @click="loading.clickAble ? close() : () => {}">
    <v-progress-circular
      :indeterminate="true"
      :rotate="0"
      :size="200"
      :value="0"
      :width="10"
      color="light-blue">
      {{ loading.message }}
    </v-progress-circular>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      loading: 'Style/loading'
    })
  },
  methods: {
    ...mapActions({
      setLoading: 'Style/setLoading'
    }),
    close () {
      this.setLoading({
        active: false,
        clickAble: this.loading.clickAble,
        message: this.loading.message
      })
    }
  }
}
</script>

<style scoped>
.overlay {
  background-color: rgba(0,0,0,0.5);
  height: 100%;
  width: 100%;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  position: absolute;
}
.cs-pointer {
  cursor: pointer;
}
</style>
